export default "__VITE_ASSET__kbcO72GB__"